//src/Components/Buttons/Button/index.tsx
import Spinner from 'Components/Spinner';
import React, { forwardRef } from 'react';

export type ButtonTheme =
  | 'green-fill'
  | 'green-outline'
  | 'red-fill'
  | 'red-outline'
  | 'gray-outline'
  | 'gray-fill'
  | 'gray-outline-mono'
  | '';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: ButtonTheme;
  isLoading?: boolean;
}
const Button = (
  props: ButtonProps,
  ref?: React.LegacyRef<HTMLButtonElement>,
) => {
  const { theme = 'gray-outline', isLoading = false, ...rest } = props;
  return (
    <button
      {...rest}
      ref={ref}
      disabled={isLoading || props.disabled}
      className={`min-h-[32px] flex w-full disabled:cursor-default disabled:opacity-50 focus:shadow hover:shadow justify-center font-semibold items-center whitespace-nowrap cursor-pointer flex-1 p-1.5 text-sm gap-2 rounded-md ${
        theme === 'green-fill'
          ? 'border border-green bg-green text-white'
          : theme === 'green-outline'
          ? 'border border-green text-green'
          : theme === 'red-fill'
          ? 'border border-red-200 bg-red-200 text-white'
          : theme === 'red-outline'
          ? 'shadow text-gray-700 hover:text-red-200 focus:text-red-200 active:text-red-200  hover:shadow-md border border-white focus:outline-offset-0 active:translate-y-[0.5px] active:transform  active:border-red-200/70 focus:outline-none focus:border-red-200/40'
          : theme === 'gray-fill'
          ? 'border-gray-700 bg-gray-100 text-sm shadow rounded text-gray-dark'
          : theme === 'gray-outline'
          ? 'shadow text-gray-700 hover:text-green focus:text-green active:text-green  hover:shadow-md border border-white focus:outline-offset-0 active:translate-y-[0.5px] active:transform  active:border-green/70 focus:outline-none focus:border-green/40'
          : theme === 'gray-outline-mono'
          ? 'shadow text-gray-700   hover:shadow-md border border-white focus:outline-offset-0 active:translate-y-[0.5px] active:transform   focus:outline-none '
          : ''
      } ${rest.className}`}
    >
      {rest.children}

      {isLoading && <Spinner theme="gray-outline" bounce={false} />}
    </button>
  );
};

export default forwardRef(Button);
